@if ({ violations: violations$ | async }; as STATE) {
  <article class="screen-creation-form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
      <article>
        <mat-label>Type de média *</mat-label>
        <mat-radio-group
          class="circle-radio"
          formControlName="mediaType"
          (change)="onMediaTypeChange()"
        >
          @for (mediaType of mediaTypes | keyvalue; track mediaType) {
            <mat-radio-button
              [value]="mediaType.key"
              class="ads-creation-form__media-type__item"
              >{{ mediaType.value }}</mat-radio-button
            >
          }
          <mat-error
            *ngIf="
              $any(form.get('mediaType'))?.getError('httpError') as httpError
            "
          >
            <strong>{{ httpError }}</strong>
          </mat-error>
        </mat-radio-group>
      </article>
      <div class="input-group">
        <article>
          <mat-label>Nom de l'écran *</mat-label>
          <mat-form-field color="primary">
            <input matInput formControlName="name" />
            <mat-error
              *ngIf="$any(form.get('name'))?.getError('httpError') as httpError"
            >
              <strong>{{ httpError }}</strong>
            </mat-error>
          </mat-form-field>
        </article>
        <article>
          <label class="mat-label">Support *</label>
          <ng-select
            [items]="channelPagination.items"
            bindLabel="name"
            bindValue="id"
            [loading]="channelPagination.loading"
            [typeahead]="channelPagination.search$"
            (scrollToEnd)="onChannelScroll()"
            (clear)="channelPagination.clear()"
            (search)="channelPagination.search($event.term)"
            [virtualScroll]="true"
            [appendTo]="'body'"
            placeholder="Sélectionner un support"
            formControlName="channelId"
          >
          </ng-select>
        </article>
      </div>
      <button
        type="submit"
        [attr.loading]="isSubmitting()"
        [disabled]="!form.valid || isSubmitting()"
        button
      >
        Enregistrer
      </button>
    </form>
  </article>
}
